import React from "react";
import cl from "./Patch.module.css";
import leftImg from "./leftImg.png";
import qrImg from "./qr.png";
import aStore from "./astore.png";
import gplay from "./gplay.png";

export const Patch = () => {
  return (
    <div className={cl.main}>
      <div className={cl.left}>
        <div className='top'></div>
        <div className={cl.center}>
          <div className={cl.leftTitle}>
            Обновляем сайт, чтобы он стал лучше.
          </div>
          <div className={cl.leftSubtitle}>
            Мы обновляем его для вашего удобства. А пока — заходите в наше
            приложение. Там всё работает и лучшая недвижимость уже ждет вас.
          </div>
        </div>
        <div className='bot'>
          <div className={cl.leftImage}>
            <img src={leftImg} alt='leftImg' />
          </div>
        </div>
      </div>
      <div className={cl.right}>
        <div className={cl.rightImage}>
          <img src={qrImg} />
        </div>
        <div className={cl.rightTitle}>
          Отсканируйте QR и скачивайте наше приложение.
        </div>
        <div className={cl.rightStores}>
          <a
            className={cl.rightStore}
            target='_blank'
            href={
              "https://play.google.com/store/apps/details?id=com.kiltapp&pcampaignid=web_share"
            }
          >
            <img src={gplay} alt='' />
          </a>
          <a
            className={cl.rightStore}
            target='_blank'
            href={
              "https://apps.apple.com/kz/app/kilt-%D0%BF%D1%80%D0%B8%D0%BB%D0%BE%D0%B6%D0%B5%D0%BD%D0%B8%D0%B5-%D0%BD%D0%B5%D0%B4%D0%B2%D0%B8%D0%B6%D0%B8%D0%BC%D0%BE%D1%81%D1%82%D0%B8/id6470451437"
            }
          >
            <img src={aStore} alt='' />
          </a>
        </div>
      </div>
    </div>
  );
};
